import { RhinoError } from '../../../error';
import { KalturaPlaybackContext } from '../../objects';

export function handlePlaybackContextErrors(playbackContext: KalturaPlaybackContext) {
  const blockAction = playbackContext.actions.find((it) => it.type === 'BLOCK');

  if (blockAction) {
    throw new RhinoError('NETWORK_API_ERROR', blockAction.type, {
      action: blockAction,
      messages: playbackContext.messages,
    });
  }
}
